export default __webpack_public_path__ + "static/media/USAworldwideTravelGroup.e9adf23b.jpg";